module.exports = __webpack_public_path__ + "img/paddocks-hero-2-0be1a3b.jpg";